import { render, staticRenderFns } from "./OperatoriList.vue?vue&type=template&id=d6230ae2&scoped=true"
import script from "./OperatoriList.vue?vue&type=script&lang=js"
export * from "./OperatoriList.vue?vue&type=script&lang=js"
import style0 from "./OperatoriList.vue?vue&type=style&index=0&id=d6230ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6230ae2",
  null
  
)

export default component.exports